export default __webpack_public_path__ + "static/media/algoColL1.a1e95dbc.svg";